// extracted by mini-css-extract-plugin
export var container = "licensed-module--container--cd543";
export var content = "licensed-module--content--d901c";
export var graphic = "licensed-module--graphic--bd241";